/*
 * Module for Forward DROP Distribution Election step
 */
rs.module("content/retirementapplication/forwarddropdistribution",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors) {
            const distributionRadios = $.js(jsSelectors.distributionRadios, { multiple: true });
            const rolloverDestinations = $.js(jsSelectors.rolloverDestinations);
            const rolloverDestinationRadios = $.js(jsSelectors.rolloverDestinationRadios, { multiple: true, required: false });
            const partialDistributionDetails = $.js(jsSelectors.partialDistributionDetails);
            const fullDistributionDetails = $.js(jsSelectors.fullDistributionDetails);
            const fullRolloverDetails = $.js(jsSelectors.fullRolloverDetails);
            const partialDistributionText = $.js(jsSelectors.partialDistributionText);
            const partialPaymentAmount = $.js(jsSelectors.partialPaymentAmount, { required: false });
            const fullRolloverCard = $.js(jsSelectors.fullRolloverCard);
            const partialDistributionCard = $.js(jsSelectors.partialDistributionCard);

            function toggleDistributionOptions() {
                const selectedOption = parseInt(
                    $('input[name="DistributionOptionKey"]:checked').val() || '0'
                );

                // Hide all sections first
                rolloverDestinations.hide();
                partialDistributionDetails.hide();
                fullDistributionDetails.hide();
                fullRolloverDetails.hide();
                partialDistributionText.hide();

                // Show appropriate section based on selection
                if (selectedOption === 1) {
                    // Full Distribution
                    fullDistributionDetails.show();
                } else if (selectedOption === 2) {
                    // Full Rollover - position the shared rollover destination section under this option
                    rolloverDestinations.insertAfter(fullRolloverCard);
                    rolloverDestinations.show();
                    fullRolloverDetails.show();
                } else if (selectedOption === 3) {
                    // Partial Distribution - position the shared rollover destination section under this option
                    rolloverDestinations.insertAfter(partialDistributionCard);
                    rolloverDestinations.show();
                    partialDistributionDetails.show();
                    partialDistributionText.show();
                }
            }

            // Event Listeners
            distributionRadios.on('change', function () {
                toggleDistributionOptions();

                // Clear business errors
                eventBanner.removeAllMessages();
            });

            partialPaymentAmount.on('change', function () {
                // Clear business errors
                eventBanner.removeAllMessages();
            });

            rolloverDestinationRadios.on('change', function () {
                // Clear business errors
                eventBanner.removeAllMessages();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
